// extracted by mini-css-extract-plugin
export default {"footer":"IssueFieldPicker-module__footer--mYJzU"};